import React from 'react';

class Loader extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			show: false
		}
		this.types = {};
		this.Toggle = this.Toggle.bind(this);
	}

	Toggle(show, type) {
		if (typeof (show) !== 'boolean')
			show = !this.state.show;

		if (typeof (type) !== 'string')
			type = 'default';

		this.types[type] = show;
		show = Object.values(this.types).indexOf(true) !== -1;

		//

		this.setState({ show: show })
	}

	render() {
		return <div className={'loader' + (this.state.show ? ' show' : '')}>
			<div className="wrapper">
				<span></span>
				<span></span>
				<span></span>
			</div>
		</div>
	}
}

export default Loader;